import React, { Component } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import {
    closeHelp,
    closeModal,
} from "redux/actions/global";
import { t } from "utils";

class LivesearchOnboarding extends Component {
    handleClick = () => {
        this.props.closeHelp('livesearchOnboarding');
        this.props.closeModal();
        if (typeof this.props.onClose === "function") {
            this.props.onClose();
        }
    }

    render() {
        return (
            <div
                tabIndex="1"
                className={classnames(
                    "modal-content",
                    "livesearch-onboarding-wrapper",
                )}>
                <div className="livesearch-onboarding">


                    <div className="livesearch-onboarding-content">
                        <button
                            className="close-button"
                            onClick={this.handleClick}
                            aria-label="Cerrar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div className="imgWrapper">
                            <img
                                alt="Simplificamos el proceso"
                                className="d-block w-100"
                                src="/images/step/fst.png"
                            />
                        </div>

                        <div className="livesearch-onboarding-text">
                            <h3>{t('livesearch_onboarding.title')}</h3>
                            <p>{t('livesearch_onboarding.description')}</p>
                        </div>
<div className="livesearch-onboarding-buttons">
                        <button
                            className="btn btn-primary"
                            onClick={this.handleClick}>
                            {t('livesearch_onboarding.start_button')}
                        </button>
                    </div></div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({ profile: state.global.profile });

const actions = {
    closeHelp,
    closeModal,
};

export default connect(mapStateToProps, actions)(LivesearchOnboarding);
